// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3N5Snhe6x{display:flex;align-items:center}._3N5Snhe6x._7FsFQqWSx{justify-content:flex-end}._3N5Snhe6x>*{flex:0 0 auto;margin-right:8px}._3N5Snhe6x>*:last-child{margin-right:0}._2RnQaH3Lx{display:table;border-collapse:separate;border-spacing:8px 0;margin-left:-8px;margin-right:-8px}._2RnQaH3Lx>*{display:table-cell;vertical-align:middle}._2RnQaH3Lx>*:first-child:nth-last-child(1),._2RnQaH3Lx>*:first-child:nth-last-child(1) ~ *{width:100%}._2RnQaH3Lx>*:first-child:nth-last-child(2),._2RnQaH3Lx>*:first-child:nth-last-child(2) ~ *{width:50%}._2RnQaH3Lx>*:first-child:nth-last-child(3),._2RnQaH3Lx>*:first-child:nth-last-child(3) ~ *{width:33.33333%}._2RnQaH3Lx>*:first-child:nth-last-child(4),._2RnQaH3Lx>*:first-child:nth-last-child(4) ~ *{width:25%}._2RnQaH3Lx>*:first-child:nth-last-child(5),._2RnQaH3Lx>*:first-child:nth-last-child(5) ~ *{width:20%}._2RnQaH3Lx>*:first-child:nth-last-child(6),._2RnQaH3Lx>*:first-child:nth-last-child(6) ~ *{width:16.66667%}._2RnQaH3Lx>*>*{width:100%}._1YrpNpL3x{width:100%;margin-left:0}._6wGdkgBSx{width:100%;justify-content:space-between}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"container": "_3N5Snhe6x",
	"right": "_7FsFQqWSx",
	"equal-width": "_2RnQaH3Lx",
	"equalWidth": "_2RnQaH3Lx",
	"full-width": "_1YrpNpL3x",
	"fullWidth": "_1YrpNpL3x",
	"between": "_6wGdkgBSx"
};
module.exports = exports;
